// App.tsx - Main component with routing

import React from 'react';
import {
  HashRouter as Router,
  Routes,
  Route,
  useLocation,
} from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Store from './pages/Store';
import Podcast from './pages/Podcast';
import Blog from './pages/Blog';
import Contact from './pages/Contact';
import AdminLogin from './pages/admin/Login';
import Dashboard from './pages/admin/Dashboard';
import { ProtectedRoute } from './components/admin/ProtectedRoute';
import './styles/App.css';
import Checkout from './pages/Checkout';
import CheckoutSuccess from './pages/CheckoutSuccess';
import CheckoutCancel from './pages/CheckoutCancel';
import { CartProvider } from './context/CartContext';

// Wrapper component to conditionally render Header and Footer
const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  // Keep header/footer hidden for admin routes, but show for admin login
  const isAdminRoute =
    location.pathname.startsWith('/admin') &&
    location.pathname !== '/admin/login';

  if (isAdminRoute) {
    return <>{children}</>;
  }

  return (
    <>
      <Header />
      <div className="content">{children}</div>
      <Footer />
    </>
  );
};

function App() {
  return (
    <CartProvider>
      <Router>
        <Layout>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<Home />} />
            <Route path="/store" element={<Store />} />
            <Route path="/podcast" element={<Podcast />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/checkout/success" element={<CheckoutSuccess />} />
            <Route path="/checkout/cancel" element={<CheckoutCancel />} />

            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />

            {/* TODO: [FIRESTORE-INTEGRATION] Add more admin routes as needed
            Examples:
            - /admin/products/new
            - /admin/products/edit/:id
            - /admin/orders
            - /admin/analytics
            */}
          </Routes>
        </Layout>
      </Router>
    </CartProvider>
  );
}

export default App;
